export const fallbackImg = '/logo.png';

export function toImageUrl(value) {
  if (!value) return fallbackImg;
  if (typeof value !== 'string') return fallbackImg;

  const v = value.trim();
  if (!v) return fallbackImg;

  if (v.startsWith('data:')) return v;
  if (/^https?:\/\//i.test(v)) return v;

  const clean = v.startsWith('/') ? v : `/${v}`;
  return `${window.location.origin}${clean}`;
}
